ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
ConfirmationModal = require 'components/common/confirmation_modal'
ConnectStore = require 'components/enhancers/connect_store'
{ kebabCase } = require 'lodash'
MiniDSActions = require 'actions/mini_ds_actions'
MiniDSStore = require 'stores/mini_ds_store'
Modal = require 'components/common/modal'
{ HANDOUT_FORM } = require 'lib/handouts_helpers'
{ MDA_HANDOUT, MINI_DOCUMENT_DOC } = require 'lib/db_docs/doc_types'
mediator = require 'mediator'
{ ExtractionForm } = require 'components/covid_extraction_form/extraction_form'
{ useState } = React
{ useCoffeeCallback, useI18n } = require 'lib/react_utils'

TEMPLATES = ['condition', 'procedure']

DOC_FORM =
  main:
    [
      fieldKey: 'name'
      type: 'string'
      showClear: false
      useControlledInput: true
    ,
      fieldKey: 'template'
      type: 'select'
      disabled: not _.includes mediator.user.getAccessRights(), 'admin'
      options: _.map TEMPLATES, (value) -> { value, text: $.t "docsec:templates.#{value}" }
      showClear: false
    ]

storeConnector =
  MiniDSStore: (Store) ->
    originalDocument: Store.getEditingDocument()
    applying: Store.isApplying()

MiniDocumentModal = ({ originalDocument, applying, documentType }) ->
  namespace = if documentType is MDA_HANDOUT then 'mda:handouts' else 'docsec:mini_ds'
  i18n = useI18n(namespace)
  [doc, setDoc] = useState(originalDocument)

  onApply = useCoffeeCallback [doc, originalDocument], ->
    if doc.get('_id')
      MiniDSActions.updateDocument(doc.toJS())
    else
      MiniDSActions.createDocument(doc.toJS(), { docType: documentType || MINI_DOCUMENT_DOC })

  onChange = useCoffeeCallback [originalDocument, setDoc, doc], (field, value) ->
    setDoc doc.withMutations (docMutable) ->
      docMutable.set field, value
      if field is 'name' and not originalDocument.slug
        docMutable.set 'slug', kebabCase value

      if documentType is MDA_HANDOUT and field is 'parentTopic'
        docMutable.setIn ['options', 'parentTopicId'], value.get('_id')
        docMutable.set 'template', value.get('template')
      else
        docMutable.set field, value

  isSubmitEnabled = if documentType is MDA_HANDOUT
    not _.isEmpty(doc.get('name')) and not _.isEmpty(doc.getIn(['options', 'parentTopicId']))
  else
    not _.isEmpty(doc.get('name')) and not _.isEmpty(doc.get('template'))

  <Modal
    isOpen
    modalSize="medium"
    title={i18n if doc.get('_id') then 'update_doc' else 'new_doc'}
  >
    <ExtractionForm
      data={doc.toJS()}
      form={if documentType is MDA_HANDOUT then HANDOUT_FORM else DOC_FORM}
      i18n={i18n}
      inModal
      onChange={onChange}
    />
    <ApplyCancelButtons
      applying={applying}
      applyLabel={i18n if doc.get('_id') then '/actions.update' else '/actions.create'}
      isSubmitEnabled={isSubmitEnabled}
      onApply={onApply}
      onCancel={MiniDSActions.closeCreateOrEditDialog}
    />
  </Modal>

module.exports = ConnectStore MiniDocumentModal, [MiniDSStore], storeConnector
